import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import QRCodeFactory from 'qrcode';
import Icon from "../../../assets/images/imtoken.svg";
import Modal from "../../Modal";
import { isClient } from "../../../utils/userAgent";
import { imTokenWalletConnectConnection } from "../../../connection";
import copy from 'copy-to-clipboard';
import { message } from "../../Message";
var StyledQRConnect = styled.div.withConfig({
  displayName: "StyledQRConnect",
  componentId: "sc-ev8jp9-0"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;min-height:385px;margin-top:-32px;.qrcode{display:flex;align-items:center;justify-content:center;margin-top:20px;img{width:300px;height:300px;display:inline-block;margin:0 auto;cursor:'none';}&::after{content:'';background-image:url(", ");background-repeat:no-repeat;background-position:center;background-size:contain;width:45px;height:45px;position:absolute;}}.text{background:#fafafc;margin:24px auto;padding:12px 25px;border:1px solid #eaecf6;box-sizing:border-box;border-radius:12px;font-weight:500;font-size:13px;line-height:16px;color:#9598ab;display:inline-flex;align-items:center;}.copy{cursor:pointer;color:#898d97;font-size:15px;margin:20px auto 0;}"], Icon);

var ConnectQRCodeModal = function ConnectQRCodeModal(_ref) {
  var qrcode = _ref.qrcode,
      onDismiss = _ref.onDismiss;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(''),
      qrCodeUri = _useState[0],
      setQrCodeUri = _useState[1];

  var copyWcUri = function copyWcUri() {
    copy(qrcode);
    message.success(t('copy_wc_uri_success'));
  };

  var getQRCodeUri = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!qrcode) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return QRCodeFactory.toDataURL(qrcode, {
              quality: 1,
              margin: 0,
              width: 600 // 2 times of dom width

            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            return _context.abrupt("return", '');

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [qrcode]);
  useEffect(function () {
    getQRCodeUri().then(function (uri) {
      setQrCodeUri(uri);
    });
  }, [qrcode]);
  return __jsx(Modal, {
    title: t('use_imtoken_scan'),
    isOpen: true,
    onDismiss: onDismiss,
    animate: false
  }, __jsx(StyledQRConnect, null, __jsx("div", {
    className: "qrcode"
  }, __jsx("img", {
    src: qrCodeUri,
    alt: "qrcode"
  })), __jsx("div", {
    className: "copy",
    onClick: copyWcUri
  }, t('copy_wc_uri'))));
};

var QRCODE_MODAL_WRAPPER_ID = 'QRCODE_MODAL_WRAPPER_ID';

var getModalWrapper = function getModalWrapper() {
  if (!isClient) return null;
  var dom = document.getElementById(QRCODE_MODAL_WRAPPER_ID);
  if (dom) return dom;
  var wrapper = document.createElement('div');
  wrapper.setAttribute('id', QRCODE_MODAL_WRAPPER_ID);
  document.body.appendChild(wrapper);
  return wrapper;
};

export var hideImTokenQRCodeModal = function hideImTokenQRCodeModal(cb) {
  if (!isClient) return;
  var modalWrapper = getModalWrapper();

  if (modalWrapper) {
    ReactDOM.unmountComponentAtNode(modalWrapper);
    if (cb) cb();
  }
};
export var showImTokenQRCodeModal = function showImTokenQRCodeModal(uri, cb) {
  console.log('open', uri);
  var modalWrapper = getModalWrapper();
  if (!modalWrapper) return;
  ReactDOM.render(__jsx(ConnectQRCodeModal, {
    qrcode: uri,
    onDismiss: function onDismiss() {
      if (imTokenWalletConnectConnection.connector) {
        imTokenWalletConnectConnection.connector.deactivate();
      }

      hideImTokenQRCodeModal();
    }
  }), modalWrapper);
};
var ImTokenQRCodeModal = {
  open: showImTokenQRCodeModal,
  close: hideImTokenQRCodeModal
};
export default ImTokenQRCodeModal;